<ng-content></ng-content>
@if (split._isDragging()) {
  <div class="as-iframe-fix"></div>
}
